import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import AccessRightsLog from "@/components/AccessRightsLog";

export default function AccessRightsPanel({ person, groups, onSaved }) {
  const [draft, setDraft] = useState(person.permissions || []);
  const [saving, setSaving] = useState(false);
  const [logKey, setLogKey] = useState(0);
  const toggle = (k) => setDraft((d) => (d.includes(k) ? d.filter((x) => x !== k) : [...d, k]));
  const toggleGroup = (g, on) => {
    const keys = g.areas.map((a) => a.key);
    setDraft((d) => (on ? [...new Set([...d, ...keys])] : d.filter((k) => !keys.includes(k))));
  };
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/users/${person.user_id}/permissions`, { permissions: draft });
      setLogKey((k) => k + 1);
      onSaved(data);
      toast.success("Zugänge gespeichert");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setSaving(false); }
  };
  const id = person.user_id;
  return (
    <div className="mt-3 border border-slate-200 bg-slate-50 p-3 min-w-[320px]" data-testid={`coach-rights-panel-${id}`}>
      <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-2">Bereiche & Unterbereiche freischalten</div>
      <div className="space-y-3">
        {groups.map((g) => {
          const all = g.areas.every((a) => draft.includes(a.key));
          return (
            <div key={g.key} data-testid={`rights-group-${id}-${g.key}`}>
              <label className="flex items-center gap-1.5 text-[11px] font-bold text-slate-900 cursor-pointer mb-1">
                <input type="checkbox" checked={all} onChange={() => toggleGroup(g, !all)} className="accent-[#00CCC9] w-3 h-3"
                  data-testid={`coach-right-group-${id}-${g.key}`} />
                {g.label}
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 pl-4">
                {g.areas.map((a) => (
                  <label key={a.key} className="flex items-start gap-1.5 text-[11px] text-slate-700 cursor-pointer">
                    <input type="checkbox" checked={draft.includes(a.key)} onChange={() => toggle(a.key)}
                      className="accent-[#00CCC9] w-3 h-3 mt-0.5" data-testid={`coach-right-${id}-${a.key}`} />
                    {a.label}
                  </label>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <button onClick={save} disabled={saving}
        className="mt-3 w-full px-3 py-1.5 bg-slate-900 text-white text-[10px] font-bold uppercase tracking-overline hover:bg-black disabled:opacity-50"
        data-testid={`coach-rights-save-${id}`}>
        {saving ? "Speichert…" : "Zugänge speichern"}
      </button>
      <AccessRightsLog userId={id} groups={groups} refreshKey={logKey} />
    </div>
  );
}
